import kenobi from "../../assets/kenobi.svg"
import Sidebar from "../../components/Sidebar"

export default function NotFound(){
    return (
        <div className="page-wrapper">
            <div class="background">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="not-found-wrapper">
                <div className="not-found-wrapper-text">
                    <span className="not-found-small not-found-text">
                        HTTP 404 Not Found
                    </span>
                    <span className="not-found-big not-found-text">
                        This is not the page you are looking for...
                    </span>

                </div>
                <div className="not-found-wrapper-image">
                    <img
                        src={kenobi}
                    />
                </div>
            </div>

        </div>
    )
}